<div class="input-text">
  <label class="input-text__label" *ngIf="data.label.length">{{data.label}}<span *ngIf="isRequired" class="input-text__required">*</span></label>

  <div class="input-text__input-wrapper">
    <input type="text" [placeholder]="data.placeholder" [value]="data.value" (keyup)="onChange($event)">
  </div>
</div>
